import { Typography } from '@mui/material';

export const PasswordReset = () => {
  return <Typography sx={{ m: 10 }}>Coming soon.</Typography>;
};
